import { SHARED_ROUTES } from '../routes';
import type { Mode, ConsultationState } from '../types/graph';
import { isMmgVariant } from './mmg';

/**
 * Where an entry lands once its mode and consultation are known. An invitation
 * to a no-appointment consultation has no landing, except the MMG one: an MMG
 * invitation only ever comes from the kiosk continuation SMS, and every kiosk
 * check-in is a no-appointment consultation (ALDO-2759).
 */
export const getLandingRoute = (
  mode: Mode | undefined,
  consultation: ConsultationState,
): string => {
  if (mode?.includes('LINK') && consultation.professional?.slug) {
    return `/professional/${consultation.professional.slug}`;
  }

  if (mode === 'INVITATION' && consultation.practice) {
    if (consultation.noAppointment && !isMmgVariant(consultation.variant)) {
      return SHARED_ROUTES.ERROR;
    }
    return SHARED_ROUTES.LANDING_PAGE;
  }

  return SHARED_ROUTES.ERROR;
};
